const _excluded = ["inputService", "label", "disabled", "commitOnChange", "debounceRate", "wrapperProps", "hideLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { useInput } from '../../../machines/inputMachine/useInput';
import { useDebounce } from 'react-use';
import { onChangeHandler, onBlurHandler, onFocusHandler, commitChanges } from '../SharedTextfieldControlFunctions';
import { Stack } from '../../Stack';
import { MaskedTextField } from '../../MaskedTextField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MaskedTextFieldControl = _ref => {
  let {
      inputService,
      label,
      disabled = false,
      commitOnChange,
      debounceRate,
      wrapperProps,
      hideLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });

  // A flag to determine whether the input `value` has changed,
  // when the form has just been initialised.
  // Please see the body of `commitChanges` for more details.

  // Basically, when an `InputGroup` form first loads, it
  // will first set the initial value, which in turn triggers
  // an attempt to validate the field. This can possibly cause the field
  // to display error messages on initialisation, when you only really want to display
  // error messages when a change is made.

  // This mechanism is a crude attempt to negate that. It's possible
  // this issue can be solved within the `Inputgroup` and `InputControl`
  // State machines.
  const [isInit, setIsInit] = React.useState(true);
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(inputService);
  if (commitOnChange) {
    useDebounce(commitChanges(send, isInit, setIsInit), debounceRate !== null && debounceRate !== void 0 ? debounceRate : 200, [value]);
  }
  return /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({}, wrapperProps), {}, {
    children: [/*#__PURE__*/_jsx(MaskedTextField, _objectSpread(_objectSpread({}, props), {}, {
      name: name,
      value: value || '',
      onChange: onChangeHandler(send),
      onBlur: onBlurHandler(send),
      onFocus: onFocusHandler(send),
      label: hideLabel ? undefined : label ? label : name,
      disabled: disabled
    })), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  }));
};